import styled from "styled-components";

export const CardInfoStyle = styled.div.attrs(() => ({
  className: "mt-2",
}))``;
